import { useCallback, useEffect, useState } from 'react';
import CompanyDataService from '../services/CompanyDataService';
import { isStateReference, validateStateProvince } from '../stateProvince';

export default function useStateProvinceValidation() {
    const [reference, setReference] = useState({});
    const [status, setStatus] = useState('loading');
    const [fieldError, setFieldError] = useState('');
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let active = true;
        setStatus('loading');
        CompanyDataService.getAllStates().then(response => {
            if (!isStateReference(response.data)) throw new Error('Invalid state reference');
            if (active) {
                setReference(response.data);
                setStatus('ready');
            }
        }).catch(() => { if (active) setStatus('error'); });
        return () => { active = false; };
    }, [attempt]);
    const validate = useCallback(record => {
        const result = validateStateProvince(record, reference, status);
        setFieldError(result.message);
        return result.valid ? { ...record, StateProvince: result.value } : null;
    }, [reference, status]);
    return { reference, status, fieldError, setFieldError, validate, retry: () => setAttempt(value => value + 1) };
}
